import { Directive, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { BrandingField } from '@app/core/models/branding.models';
import { BrandingService } from '@app/core/services/branding.service';

@Directive({
  selector: '[appNavBrandingColor]',
  standalone: true,
})
export class NavBrandingColorDirective implements OnInit {
  @Input() isActiveBrandingColor: boolean;
  @HostBinding('style.background') background: string;
  highlightedColorLeftSideMenuItem: string;

  constructor(private brandingService: BrandingService) {}

  ngOnInit(): void {
    this.brandingService.brandingData$.subscribe((brandingData) => {
      this.highlightedColorLeftSideMenuItem = brandingData[BrandingField.FieldHighlightColorLeftSideMenuItems];
    });
  }

  @HostListener('mouseover')
  onMouseOver() {
    this.background = this.highlightedColorLeftSideMenuItem;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.background = this.isActiveBrandingColor ? this.highlightedColorLeftSideMenuItem : 'transparent';
  }
}
